interface Props {
    width?: number
    height?: number
    primaryColor?: string
    secondaryColor?: string
}

const SvgLogo = ({
    width = 68,
    height = 38,
    primaryColor = '#CCCCCC',
    secondaryColor = '#5489FF',
}: Props) => (
    <svg
        viewBox="0 0 68 38"
        width={width}
        height={height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.72919 12.1413C8.53568 13.1929 8.02506 14.3013 7.1401 14.9621C6.52049 15.4247 5.73429 15.6563 4.95883 15.5337C4.02347 15.3858 3.27903 14.7613 3.27903 13.7876C3.27903 12.6732 4.07193 12.0511 5.8174 11.7663C6.25873 11.6942 6.70283 11.6356 7.14524 11.5703C7.4798 11.5209 7.81436 11.4715 8.14888 11.4222C8.33575 11.3946 8.61488 11.3639 8.79822 11.349C8.804 11.6025 8.77905 11.8704 8.72919 12.1413ZM11.926 17.5223C11.926 16.6137 11.925 15.213 11.925 13.4509V9.58889C11.925 5.83111 10.18 4.19833 6.26648 4.19833C2.85567 4.19833 0.634154 5.90912 0.422626 8.68192H3.67525C3.78105 7.20467 4.7064 6.40136 6.26648 6.40136C7.95906 6.40136 8.72573 7.23081 8.72573 9.17416V9.51137L5.92294 9.84808C3.83393 10.1335 2.56451 10.4702 1.61296 11.0143C0.555101 11.6626 0 12.6989 0 13.9431C0 16.2498 1.79781 17.7789 4.49487 17.7789C6.63676 17.7789 8.3026 16.8196 8.93729 15.2386C8.96346 16.0425 8.95302 16.8791 8.95302 17.5223H11.926Z"
            fill={primaryColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.2163 7.01662V4.30107H17.9905V0H14.9222V13.4507C14.9222 16.0683 15.8755 17.652 19.0481 17.701C19.9232 17.7145 20.4485 17.7145 21.2163 17.7145V15.0032C20.7956 15.0032 20.4496 15.0057 19.9207 15.0057C18.5986 15.0057 17.9905 14.3578 17.9905 12.9583V7.01662H21.2163Z"
            fill={primaryColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.34874 26.8247H21.2168V24.0231H0.34874V26.8247Z"
            fill={secondaryColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.7827 30.5633C31.8786 30.5633 30.9778 29.1882 30.9778 26.7784V25.897C30.9778 23.4348 31.9053 22.0597 33.7827 22.0597C35.8183 22.0597 36.7721 23.6165 36.7721 26.3118C36.7721 29.0589 35.7654 30.5633 33.7827 30.5633ZM34.8147 19.5215C32.8577 19.5215 31.3777 20.5065 30.6901 21.8539V15.003H27.6218V32.791H30.5011L30.5052 30.6916C31.1923 32.1427 32.7257 33.1021 34.6822 33.1021C37.9879 33.1021 39.8673 30.3806 39.8673 26.3118C39.8673 22.2948 38.0406 19.5215 34.8147 19.5215Z"
            fill={primaryColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.249 27.4641C49.9244 29.2298 48.5551 31.1844 46.479 30.8564C45.5438 30.7086 44.7992 30.0839 44.7992 29.1102C44.7992 27.9959 45.5919 27.3738 47.3374 27.0889C47.779 27.017 48.2231 26.958 48.6654 26.8928C48.9996 26.8436 49.3342 26.7943 49.6688 26.7445C49.8558 26.7173 50.1348 26.6865 50.3182 26.6716C50.324 26.9252 50.2989 27.1931 50.249 27.4641ZM53.4461 32.8449C53.4461 31.9364 53.445 30.5356 53.445 28.7735V24.9115C53.445 21.1538 51.7002 19.521 47.7866 19.521C44.3757 19.521 42.1541 21.2318 41.9427 24.0045H45.1953C45.3012 22.5273 46.2264 21.724 47.7866 21.724C49.479 21.724 50.2459 22.5535 50.2459 24.4968V24.834L47.4431 25.1707C45.354 25.4561 44.0845 25.7928 43.1328 26.3369C42.0752 26.9852 41.5201 28.0215 41.5201 29.2657C41.5201 31.5725 43.3177 33.1016 46.0149 33.1016C48.1568 33.1016 49.8226 32.1422 50.4573 30.5613C50.4835 31.3651 50.4731 32.2017 50.4731 32.8449H53.4461Z"
            fill={primaryColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.6951 19.8325L62.0772 28.3074C61.8653 28.9809 61.7738 29.3884 61.6593 29.7523C61.6593 29.7523 61.4274 28.9162 61.2313 28.3074L58.3489 19.8325H54.8586L60.015 32.6611L59.7504 33.4388C59.2744 34.8903 58.4813 35.5119 56.9742 35.5119C56.6303 35.5119 56.3179 35.5087 55.7579 35.5087L55.7651 38H57.2388C60.0678 38 61.8395 36.8335 63.0293 33.5163L68.0001 19.8325H64.6951Z"
            fill={primaryColor}
        />
    </svg>
)

export default SvgLogo
